@import './../../../../../styles/global/global-imports';

li {
  margin-right: .5rem;

  a {
    color: inherit;
    text-decoration: none;
    font-size: $font-size-16;
    line-height: $font-size-20;

    &:hover {
      color: var(--themeFontColor);
    }
  }

  &.breadcrumb-item--arrow {
    &:before {
      content: "\EA01";
      display: inline-block;
      speak: none;
      font-family: iconfont;
      line-height: 1;
      font-weight: 400;
      font-style: normal;
      font-variant: normal;
      text-transform: none;
      font-size: 12px;
      margin-right: .5rem;
      color: inherit;
    }
  }

  &.breadcrumb-item--active {
    a {
      color: var(--themePrimaryColor);
    }
  }
}
